import Vue from "vue";
import Filter from "./components/Filter.vue";
import Icon from "./components/Icon.vue";
import Loader from "./components/Loader.vue";

Vue.config.productionTip = false;
Vue.component("Icon", Icon);
Vue.component("Loader", Loader);

let component = {};

if ($(".js-selection-form").length) {
  component = new Vue({
    render: h => h(Filter)
  }).$mount(".js-selection-form");
}

export default component;
